import { Printer } from "../../masterdata/models/printer";
import { SamplePrintTemplate } from './SamplePrintTemplate';


export class OrderPrintBarcode {

    orderId: string;
    primersIds: Array<string> = [];
    samplesIds: Array<SamplePrintTemplate> = [];
    barcode: string;
    selectedPrinter: Printer;
    selectedPlatePrinter: Printer;
    selectedTubePrinter: Printer;
    printType: string;
    printerTemplate: string;
    numberOfCopies: number;
}